import { useState } from "react";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useClarityConsent } from "../../hooks/useClarityConsent";
import { isProduction } from "../../services/config";
import "./ClarityConsentBanner.css";

const ClarityConsentBanner = () => {
    const { t } = useTranslation();
    const { grant, deny, hasDecided } = useClarityConsent();
    const [dismissed, setDismissed] = useState(hasDecided());

    if (dismissed) return null;

    const handleGrant = () => {
        grant();
        setDismissed(true);
    };

    const handleDeny = () => {
        deny();
        setDismissed(true);
    };

    if (!isProduction) return null;

    return (
        <>
            <div className="consent-backdrop" />
            <div className="consent-banner">
                <Typography variant="body1" className="consent-banner__text">
                    {t("clarityBanner.text")}
                    <a
                        href="https://gouspa.org/privacy-policy"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t("clarityBanner.privacyPolicy")}
                    </a>
                </Typography>
                <div className="consent-banner__actions">
                    <Button
                        variant="accent"
                        className="consent-banner__btn consent-banner__btn--accept"
                        onClick={handleGrant}
                    >
                        {t("clarityBanner.accept")}
                    </Button>
                    <Button
                        variant="outlined"
                        className="consent-banner__btn consent-banner__btn--decline"
                        onClick={handleDeny}
                    >
                        {t("clarityBanner.decline")}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default ClarityConsentBanner;
